import {lighten} from 'polished';
import styled from 'styled-components';

import {StatusWrapper} from 'components/ui-kit/PageComponents';
import {AppealSlaIndicator} from 'types';

const slaColors: Record<AppealSlaIndicator, string> = {
    [AppealSlaIndicator.GREEN]: '#43A047',
    [AppealSlaIndicator.YELLOW]: '#F57C00',
    [AppealSlaIndicator.RED]: '#FA2424',
};

export const SlaBadge = styled.span<{indicator: AppealSlaIndicator}>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;

    &::before {
        width: 14px;
        height: 14px;
        box-sizing: border-box;
        border-radius: 50%;
        background: ${(props) => slaColors[props.indicator]};
        border: 2px solid ${(props) => lighten(0.25, slaColors[props.indicator])};
        content: '';
    }
`;

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;

    button {
        width: auto;
    }
`;

export const CodeNotFoundBadge = styled(StatusWrapper).attrs({color: '#F54848'})`
    margin: 0;
    font-weight: 600;
`;

export const MarkingCode = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    max-width: 130px;

    .copy-button {
        display: none;
    }

    &:hover {
        .copy-button {
            display: block;
        }
    }
`;

export const MarkingCodeText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100px;
    width: 100%;
`;
